import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'src/app/_core';

@Injectable({ providedIn: 'root' })
export class NavbarService {
  private readonly _translateService = inject(TranslateService);
  private readonly _router = inject(Router);

  isLinkActiveWithFragment(item: MenuItem): boolean {
    const tree = this._router.parseUrl(this._router.url);
    const currentUrl =
      '/' +
      (tree.root.children['primary']?.segments
        .map((s: any) => s.path)
        .join('/') ?? '');

    const url = item.url.startsWith('/') ? item.url : '/' + item.url;
    const itemUrl = this._translateService.instant(url);

    const fragmentMatches = item.fragment
      ? tree.fragment === item.fragment
      : true;

    return currentUrl === itemUrl && fragmentMatches;
  }
}
